<template>
  

    <div>
      <newProductType :modelValue="Open" @update:modelValue="Open = $event" @refresh="callRefresh"/>
        <div class="row mb-8">
            <div class="col-6 d-flex justify-content-start">
                <v-card-title>
                    {{ $t('routes.ProductType') }}
                </v-card-title>
            </div>
            <div class="col-6 d-flex justify-content-end">
                    <genericBtnComponent  :ClickFun="navigateToNewProductType" svg="2"
                    :Title="$t('ProductType.create')" />
            </div>
            
        </div>
        <v-card elevation="0">
            <ProductTypeList  ref="productTypeListRef"   :showFilterDialog="showFilterDialog" @open-filter-dialog="openFilterDialog"/>
        </v-card>
        
    </div>
</template>
<script>
import { isClient } from "@/api/index";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import ProductTypeList from "@/components/ProductType/ProductTypeList.vue";
import newProductType from "@/components/ProductType/newProductType.vue";
export default {
    components: {
        genericBtnComponent,
        ProductTypeList,
        newProductType
    },
    data() {
        return {
            showFilterDialog : false,
            Open : false,
            ComponentKey : 0,

        }
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.purchasesOrder');
    },
    methods: {
        openFilterDialog(newValue){
            this.showFilterDialog = newValue;
        },
        closeFilterDialog() {
            this.showFilterDialog = false;
        },
        navigateToNewProductType() {
          this.Open = true;
        },
        isClient() {
            return isClient()
        },
        callRefresh(){
            this.$refs.productTypeListRef.loadList();
        }
    }
};

</script>
